<script>
	export let options = [];
	export let value = {};

	function check(e) {
		const id = e.currentTarget.dataset.id;
		if (!value[id]) value[id] = true;
		else delete value[id];

		value = value;
	}
</script>

{#each options as option}
	<li>
		<label on:click={check} data-id={option.id}>
			<span class="box" class:selected={value[option.id]} />
			<span class="name">{option.name}</span>
		</label>
	</li>
{/each}

<style>
	li:first-child {
		margin-top: 0;
	}
	li {
		margin-top: 1.6rem;
	}
	label {
		vertical-align: top;
		cursor: pointer;
	}
	.box {
		float: left;
		width: 18px;
		height: 18px;
		border: 2px solid rgba(1, 1, 1, 0.5);
		position: relative;
		border-radius: 0.2rem;
		transition: 0.2s all ease-in-out;
		display: block;
	}
	.box.selected {
		background-color: #7e57c2;
		border-color: #7e57c2;
	}
	.box.selected:before {
		content: "";
		display: block;
		background: url("data:image/svg+xml,%3Csvg width='18' height='14' viewBox='0 0 18 14' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.545 10.692L16.175.086l1.41 1.402-12.04 11.96-5.597-5.56 1.364-1.4' fill='%23FFF' fill-rule='evenodd'/%3E%3C/svg%3E%0A")
			no-repeat center center;
		background-size: contain;
		width: 15px;
		height: 15px;
		position: absolute;
		top: 50%;
		left: 50%;
		margin: -7.5px 0 0 -7px;
		transition: 0.2s all ease-in-out;
	}
	.name {
		font-size: 1.6rem;
		line-height: 2rem;
		color: rgba(0, 0, 0, 0.6);
		margin-left: 3rem;
		margin-bottom: 0.8rem;
		display: block;
	}
</style>
